<template>
  <li class="flex py-1 pl-6">
    <div class="w-10 h-10 bg-gray-200 rounded-md dark:bg-gray-700 animate-pulse"></div>
    <div class="flex flex-col self-end ml-2">
      <div class="w-32 h-4 bg-gray-200 dark:bg-gray-700 animate-pulse" />
      <div class="w-8 h-2 my-1 bg-gray-200 dark:bg-gray-700 animate-pulse" />
    </div>
  </li>
</template>
